import {
  ProviderFilters,
  SearchFilter,
} from '../../../WbGeneralPurposeEntityPicker';
import { WbResponsiveTableToolbar } from '../../../WbTable/WbResponsiveTableToolbar';
import useUserContext from './UserProvider';

export interface UsersFilters extends ProviderFilters {}

enum AvailableUsersFilters {
  search = 'search',
}

export const UsersFiltersSection = () => {
  const { filters, changeFilters, resetFilters, templateKind } =
    useUserContext();

  const filterElement = (key: string) => {
    if (key === AvailableUsersFilters.search)
      return (
        <SearchFilter
          key={key}
          value={filters.search ?? ''}
          changeFilters={changeFilters}
        />
      );

    return <></>;
  };

  return (
    <WbResponsiveTableToolbar onClear={resetFilters} marginBottom>
      <WbResponsiveTableToolbar.Filters>
        {(templateKind?.userFilters ?? ['search']).map(filter =>
          filterElement(filter),
        )}
      </WbResponsiveTableToolbar.Filters>
    </WbResponsiveTableToolbar>
  );
};
